import { useState } from "react";
import type { ActiveFilters } from "./DataTableTypes";

/** The global search query and the per-column filters. */
export interface TableSearch {
  query: string;
  filters: ActiveFilters;
  setQuery: (query: string) => void;
  setFilter: (key: string, value: string) => void;
  /** Clears the query and every filter. */
  clear: () => void;
}

export function useTableSearch(): TableSearch {
  const [query, setQuery] = useState("");
  const [filters, setFilters] = useState<ActiveFilters>({});

  function setFilter(key: string, value: string): void {
    setFilters((prev) => ({ ...prev, [key]: value }));
  }

  function clear(): void {
    setFilters({});
    setQuery("");
  }

  return { query, filters, setQuery, setFilter, clear };
}
